/* eslint-disable multiline-ternary */
export const ststusOptions = [
  { value: "requested", label: "Project requested" },
  { value: "footage_received", label: "Footage Received" },
  { value: "assigned_to_editor", label: "Assigned to editor" },
  { value: "editing_in_progress", label: "Editing in Progress" },
  { value: "revision_in_progress", label: "Revision in progress" },
  { value: "edit_complete", label: "Edit Complete" },
];
export const ststusOptionsTab = [
  { value: "all", label: "All Projects" },
  { value: "requested", label: "Project Requested" },
  { value: "footage_received", label: "Footage Received" },
  { value: "assigned_to_editor", label: "Assigned to Editor" },
  { value: "editing_in_progress", label: "Editing in Progress" },
  { value: "revision_in_progress", label: "Revision in Progress" },
  { value: "edit_complete", label: "Edit Complete" },
  { value: "approved_by_client", label: "Approved" },
];

export const ProjectTypesLabels = [
  ["insta_video", "Instagram video"],
  ["highlight_video", "Music Highlight Video - Music only"],
  ["narrative_highlight_video", "Narrative Highlight video - Music + Dialogue"],
  ["cinematic_film", "Cinematic Feature Film - Music + Dialogue"],
  ["documentary_edits", "Documentary edits"],
];

export const fetchKeys = (data) => {
  let dt = data;
  if (dt && dt !== "null" && dt !== "undefined" && JSON.stringify(dt)) {
    try {
      dt = JSON.parse(dt);
    } catch (error) {
      return "-";
    }
    const result = Object.keys(dt)
      .map((key) => {
        const matchingLabel = ProjectTypesLabels.find(
          (label) => label[0] === key
        );
        return matchingLabel ? matchingLabel[1] : null;
      })
      .filter((label) => label !== null)
      .join(", ");
    return result;
  } else {
    return "-";
  }
};

const checkValue = (string) => {
  if (string) {
    let str = string.trim(); // Use `let` instead of `const` to allow reassignment

    if (str.includes("minute")) {
      const lastHyphenIndex = str.lastIndexOf("-");

      if (lastHyphenIndex !== -1) {
        str = `${str.slice(0, lastHyphenIndex)} ${str.slice(
          lastHyphenIndex + 1
        )}`;
        if (str.trim().split(" ")[0] !== "1") {
          str = str.replace(/\bminute\b/g, "Minutes");
        } else {
          str = str.replace(/\bminute\b/g, "Minute");
        }
        return str;
      }
    } else {
      return str;
    }
  } else {
    return "";
  }
};

// Rest of your code...

export const convertVideoData = (data) => {
  const dtt = [];
  try {
    if (data && data !== "null" && data !== "undefined") {
      Object.entries(JSON.parse(data)).forEach((item) => {
        const key = ProjectTypesLabels.filter((it) => it[0] === item[0]);
        if (key.length) {
          let val = "";
          if (Array.isArray(item[1])) {
            let valueData = "";
            item[1].forEach((dt) => {
              valueData = `${valueData} ${dt},\n`;
            });
            val = valueData.replace(/,\n$/, "");
          }
          dtt.push(
            <div key={key[0][1]} style={{ marginTop: "10px" }}>
              {key[0][1]} : {checkValue(val?.split("_")?.join("-"))}
            </div>
          );
        }
      });
      return dtt;
    } else {
      return dtt;
    }
  } catch (err) {
    return "";
  }
};

export const projectTitle = (data) => {
  const d = data.split(":");
  const key = d[0];
  const val = d[1];

  switch (key) {
    case "insta_video":
      return `Instagram Video :  ${val?.replace(/_/g, " ")}`;

    case "highlight_video":
      return `Music Highlight Video – Music Only : ${val?.replace(
        /_([^_]*)_/g,
        "-$1 "
      )}s`;

    case "narrative_highlight_video":
      return `Narrative Highlight Video – Music + Dialogue : ${val?.replace(
        /_([^_]*)_/g,
        "-$1 "
      )}s`;

    case "cinematic_film":
      return `Cinematic Feature Film – Music + Dialogue : ${val?.replace(
        /_([^_]*)_/g,
        "-$1 "
      )}s`;

    case "documentary_edits":
      return `Documentary Edits :  ${
        val === "ceremony_reception_MCE"
          ? "ceremony + reception Edit"
          : val?.replace(/_/g, " ").replace("MCE", "Edit")
      }`;
    default:
      return "-";
  }
};
